import React, { useEffect, useState } from 'react';
import choose from '@/utils/choose';

import getFeaturedLifelines from '@/api/getFeaturedLifelines';
import Slider from '@/components/Slider';
import Slide from './Slide';
import './style.css';

function LifelineSlider({ paused }) {
  const [state, setState] = useState({
    lifelines: [],
    lifelinePositions: [],
    mounted: false,
  });

  useEffect(() => {
    async function fetchLines() {
      const featuredLifelines = await getFeaturedLifelines();
      setState({ lifelines: choose(featuredLifelines, 3) });
    }
    fetchLines();
  }, []);

  const { lifelines } = state;
  return (
    <div className="slider-wrapper">
      <Slider
        className="slider--lifelines"
        autoplay={4000}
        items={currentIndex =>
          lifelines &&
          lifelines.map((lifeline, index) => (
            <Slide
              key={lifeline.uuid}
              lifeline={lifeline}
              active={currentIndex === index && !paused}
            />
          ))
        }
      />
    </div>
  );
}

export default LifelineSlider;
